import {S, calculateFa, calculateFv} from './sptCalculations';
import * as XLSX from 'xlsx'; // Import the xlsx library


const downloadExcel = (borehole, spts) => {
  console.log(borehole);
  // Create a new workbook and a worksheet
  const workbook = XLSX.utils.book_new();

  // Data to include in the sheet
  const data = [
    ["Borehole Information"],
    ["X 좌표", borehole.x],
    ["Y 좌표", borehole.y],
    ["좌표 기준", borehole.coordinate_system],
    ["원점 EPSG 코드", borehole.epsg_code],
    ["지하수위", borehole.ground_water_table],
    ["시험최종심도 또는 기반암 깊이", borehole.bedrock_depth_h],
    ["기반암 표고", borehole.first_vs_760_elevation ? borehole.first_vs_760_elevation : "측정 안됨"],
    ["토층평균전단파속도", borehole.vs_soil],
    ["지반 종류", borehole.soil_type, "임시 분류 여부", borehole.is_temp_soil_type],
    [],
    ["주소", borehole.address],
    ["지진구역", borehole.region_type],
    ['재현주기별 S, Fa,Fv', 500,1000,2400,4800],
    ['S',S(borehole.region_type, 500), S(borehole.region_type, 1000), S(borehole.region_type, 2400), S(borehole.region_type, 4800)],
    ['Fa',calculateFa(borehole.soil_type, S(borehole.region_type, 500)), calculateFa(borehole.soil_type, S(borehole.region_type, 1000)), calculateFa(borehole.soil_type, S(borehole.region_type, 2400)), calculateFa(borehole.soil_type, S(borehole.region_type, 4800))],
    ['Fv',calculateFv(borehole.soil_type, S(borehole.region_type, 500)), calculateFv(borehole.soil_type, S(borehole.region_type, 1000)), calculateFv(borehole.soil_type, S(borehole.region_type, 2400)), calculateFv(borehole.soil_type, S(borehole.region_type, 4800))],
    [],
    ["SPT Data"],
    ["레이어", "표고", "SPT-N", "SPT-D", "환산N", "Vs", "액상화 예비평가"]
  ];

  const sortedSpts = spts.sort((a, b) => b.elevation - a.elevation);
  // Add SPT data to the sheet
  sortedSpts.forEach(spt => {
    data.push([spt.layer_index, spt.elevation, spt.n, spt.d, spt.corrected_n, spt.vs, spt.liquefaction_assessment]);
  });

  // Create worksheet and append data
  const worksheet = XLSX.utils.aoa_to_sheet(data);

  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, borehole.name);

  // Define the file name
  const fileName = `${borehole.name}_정보.xlsx`;

  // Write the workbook and trigger the download
  XLSX.writeFile(workbook, fileName);
};

export default downloadExcel;